<template class="prom ">
  <div class="promote_wrap">
    <div  class="head_info">
      <p class="subject_title">中国足协{{promote_level}}教练员培训班助理讲师{{tea_name.replace(',','')}}参与课程（第{{promote_number}}次）</p>
      <p @click="downloadFile" class="download_file" v-if="false">下载助理讲师评价表</p>
    </div>
    <div class="tabel_head"  v-show="!isLoading">
      <div>理论课主题</div>
      <div>实践课主题</div>
    </div>
    <template v-if="true">
      <div style="height:450px">
        <vue-scroll :ops="ops" ref="vs">
          <el-form
            ref="form"
            :model="form"
            class="tabel_body"
            v-show="!isLoading"
          >
            <div class="theory">
              <el-form-item
                label-width="75px"
                :prop="'theoryData.'+ index +'.subject_id'"
                :label="'主题 '+ (index + 1) +':'"
                v-for="(item,index) in form.theoryData"
                :key="index"
                :rules="[{ required: true, message: '请选择理论课主题', trigger: 'change' }]"
              >
                <div  style="display: flex">
                  <el-select
                    v-model="item.subject_id"
                    :disabled="!isCanEdit"
                    @change="checkId(item.subject_id,item,{data:form.theoryData,select:theorySelect})"
                    placeholder="请选择理论课主题"
                    style="width:75%"
                  >
                    <el-option
                      v-for="item in theorySelect"
                      :key="item.subject_id"
                      :label="item.subject_name"
                      :value="item.subject_id"
                      :disabled="item.disabled" v-if="isCanEdit">
                    </el-option>
                    <el-option
                      v-for="item in form.theoryData"
                      :label="item.subject_name"
                      :value="item.subject_id"
                      :disabled="item.disabled" v-else>
                    </el-option>
                  </el-select>
                  <el-row class="exp-opt" style="width:25%" v-if="isCanEdit && ['B','A'].includes(promote_level)">
                    <el-col :span="6">
                      <el-button v-show="form.theoryData.length-1 === index" type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addTheory"
                        circle></el-button>
                    </el-col>
                    <el-col :span="8"
                      :offset="4">
                      <el-button v-show="form.theoryData.length >3"
                        type="danger"
                        size="small"
                        icon="el-icon-minus"
                        @click="delTheory(index)"
                        circle></el-button>
                    </el-col>
                  </el-row>
                </div>
                
              </el-form-item>
            </div>
            <div class="practice">
              <el-form-item
                label-width="75px"
                :prop="'practiceData.'+ index +'.subject_id'"
                :label="'主题 '+ (index + 1) +':'"
                v-for="(item,index) in form.practiceData"
                :key="index"
                :rules="[{ required: true, message: '请选择实践课主题', trigger: 'change' }]"
              >
                <div  style="display: flex">
                  <el-select
                    v-model="item.subject_id"
                    :disabled="!isCanEdit"
                    @change="checkId(item.subject_id,item,{data:form.practiceData,select:practiceSelect})"
                    placeholder="请选择实践课主题"
                    style="width:75%"
                  >
                    <el-option
                      v-for="item in practiceSelect"
                      :key="item.subject_id"
                      :label="item.subject_name"
                      :value="item.subject_id"
                      :disabled="item.disabled"
                      v-if="isCanEdit"
                    >
                    </el-option>
                    <el-option
                      v-for="item in form.practiceData"
                      :label="item.subject_name"
                      :value="item.subject_id"
                      :disabled="item.disabled"
                      v-else
                    >
                    </el-option>
                  </el-select>
  
                  <el-row class="exp-opt" style="width:25%" v-if="isCanEdit && ['B','A'].includes(promote_level)">
                    <el-col :span="6">
                      <el-button v-show="form.practiceData.length-1 === index" type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addHonor"
                        circle></el-button>
                    </el-col>
                    <el-col :span="8"
                      :offset="4">
                      <el-button v-show="form.practiceData.length >3"
                        type="danger"
                        size="small"
                        icon="el-icon-minus"
                        @click="delHonor(index)"
                        circle></el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </vue-scroll>
      </div>
    </template>
    <template v-else>
      <div class="info">
        <div class="theory_info">
          <p>理论课主题由主讲师在培训班开始后出题（五个）</p>
        </div>
        <div class="practice_info">
          <p>实践课主题由主讲师在培训班开始后出题（五个）</p>
        </div>
      </div>
    </template>
    <div class="btns sysm_tea_edit" v-show="!isLoading" v-if="isCanEdit">
      <el-button type="primary" :loading="repeatSubmit" @click="submit">保存</el-button>
      <el-button type="danger" @click="cancel">取消</el-button>
    </div>
    <yioks-loading v-if="isLoading"></yioks-loading>
  </div>
</template>

<script>
import {
  promote_subject_view,
  promote_template_data,
  promote_subject_save,
  teacher_promote_down
} from "@/api/training_teacher/api";
import commonFun from "@/assets/js/yioks";
import ops from "@/assets/js/vuescrollOption";
const { downfile } = commonFun;
  export default {
    props:["teacherId","cId","tea_name"],
    created() {
      this.getList()
    },
    components:{
      "yioks-loading": () => import("@/components/Loading/Loading"),
    },
    data() {
      return {
        ops: ops(true),
        form:{
          theoryData: [],
          practiceData: []
        },
        rules:{
          theory: [
            { required: true, message: '请选择主题', trigger: 'change' }
          ],
        },
        repeatSubmit:false,
        // practiceData:[],
        // theoryData:[],
        isCanEdit: false,
        practiceSelect:[],
        theorySelect:[],
        isLoading: true,
        promote_number:0,
        promote_level:"",
        promote_status:"",
        record_id:"",
      }
    },
    methods: {
      addHonor(){
        this.form.practiceData.push({
          evaluate: "",
          evaluate_id: null,
          indicators_score: 0,
          record_id: this.record_id,
          subject_id: "",
          subject_name: "",
          subject_type: "practice"
        });
      },
      delHonor(idx){
        if (this.form.practiceData.length === 1) return;
        this.form.practiceData.splice(idx, 1);
      },
      
      addTheory(){
        this.form.theoryData.push({
          evaluate: "",
          evaluate_id: null,
          indicators_score: 0,
          record_id: this.record_id,
          subject_id: "",
          subject_name: "",
          subject_type: "theory"
        });
      },
      delTheory(idx){
        if (this.form.theoryData.length === 1) return;
        this.form.theoryData.splice(idx, 1);
      },
      checkId(id,item,data){
        let seletcObj = {}
        data.data.forEach(i => {
          if(i.subject_id)  seletcObj[i.subject_id] = i.subject_name;
        })
        data.select.forEach(i => {
          if(i.subject_id === id){
            item.subject_name = i.subject_name;
            seletcObj[i.subject_id] = i.subject_name;
          }
          if(i.subject_name === seletcObj[i.subject_id]){
            i.disabled = true
          }else{
            i.disabled = false
          }
        });
      },
      async getList(){
        let selectData = await promote_template_data({teacher_id:this.teacherId,c_id:this.cId});
        this.practiceSelect = selectData.data.result.practiceSubjectData;
        this.theorySelect = selectData.data.result.theorySubjectData;
        this.promote_number=selectData.data.result.infoMap.promote_number;
        this.promote_level=selectData.data.result.infoMap.promote_level;
        this.promote_status=selectData.data.result.infoMap.record_status;
        this.record_id = selectData.data.result.infoMap.record_id,
        promote_subject_view({teacher_id:this.teacherId,c_id:this.cId})
        .then(res=>{
          this.isLoading = false;

          if(res.data.status=== 0){
            let practiceObj = {}
            let theoryObj = {}
            if(res.data.result.subjectData.length !== 0){
              res.data.result.subjectData.forEach(item =>{
                if(item.subject_type === "theory"){
                   this.form.theoryData.push(item)
                   theoryObj[item.subject_id] = item.subject_name
                }
                if(item.subject_type === "practice"){
                  this.form.practiceData.push(item);
                  practiceObj[item.subject_id] = item.subject_name
                }
              })
              
              this.practiceSelect.forEach(i => {
                if(practiceObj[i.subject_id]) i.disabled = true;
              });
              this.theorySelect.forEach(i => {
                if(theoryObj[i.subject_id]) i.disabled = true;
              });
            } else {
              // 2023年03.23修改 第五次 实践自选5个，理论自选8个
              if(this.promote_level === 'D'){
                for(let i = 0; i<5 ; i++){
                  this.form.theoryData.push({
                    evaluate: "",
                    evaluate_id: null,
                    indicators_score: 0,
                    record_id: selectData.data.result.infoMap.record_id,
                    subject_id: "",
                    subject_name: "",
                    subject_type: "theory"
                  });
                  this.form.practiceData.push({
                    evaluate: "",
                    evaluate_id: null,
                    indicators_score: 0,
                    record_id: selectData.data.result.infoMap.record_id,
                    subject_id: "",
                    subject_name: "",
                    subject_type: "practice"
                  });
                }
                // 理论再加仨
                for(let i = 0; i<3 ; i++){
                  this.form.theoryData.push({
                    evaluate: "",
                    evaluate_id: null,
                    indicators_score: 0,
                    record_id: selectData.data.result.infoMap.record_id,
                    subject_id: "",
                    subject_name: "",
                    subject_type: "theory"
                  });
                }
              }else if(this.promote_level === 'C'){
                // 不是D级 12+12
                for(let i = 0; i<12 ; i++){
                  this.form.theoryData.push({
                    evaluate: "",
                    evaluate_id: null,
                    indicators_score: 0,
                    record_id: selectData.data.result.infoMap.record_id,
                    subject_id: "",
                    subject_name: "",
                    subject_type: "theory"
                  });
                  this.form.practiceData.push({
                    evaluate: "",
                    evaluate_id: null,
                    indicators_score: 0,
                    record_id: selectData.data.result.infoMap.record_id,
                    subject_id: "",
                    subject_name: "",
                    subject_type: "practice"
                  });
                }
              }else if(this.promote_level === 'B' || this.promote_level === 'A'){
                // B 或 A 最少3个
                for(let i = 0; i<3 ; i++){
                  this.form.theoryData.push({
                    evaluate: "",
                    evaluate_id: null,
                    indicators_score: 0,
                    record_id: selectData.data.result.infoMap.record_id,
                    subject_id: "",
                    subject_name: "",
                    subject_type: "theory"
                  });
                  this.form.practiceData.push({
                    evaluate: "",
                    evaluate_id: null,
                    indicators_score: 0,
                    record_id: selectData.data.result.infoMap.record_id,
                    subject_id: "",
                    subject_name: "",
                    subject_type: "practice"
                  });
                }
              }
              
            }
            this.isCanEdit = res.data.result.isCanEdit
          }
        })
      },
      cancel(){
        this.$emit("promoteCancel",false)
      },
      submit(){
        this.$refs["form"].validate(valid => {
          if (valid) {
            this.repeatSubmit = true
            promote_subject_save({
              teacher_id:this.teacherId,
              c_id:this.cId,
              subjectData:JSON.stringify([...this.form.theoryData,...this.form.practiceData])})
            .then(res=>{
              if(res.data.status === 0){
                this.cancel();
              }
              this.repeatSubmit = false
            }).catch(err=>{
              this.repeatSubmit = false
              console.log(err);
            })
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      downloadFile(){
        teacher_promote_down({
          teacher_id:this.teacherId,
          c_id:this.cId,
        }).then(res=>{
          if (res.data.status===0){
              downfile(res.data.result.file_url)
          } else{
            this.$message.error(res.data.msg)
          }
        }).catch(err=>{
          console.log(err)
        })
      }
    },
  }
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.promote_wrap
  height 570px
  .head_info
    display flex
    justify-content space-around
    align-items center
    margin-bottom 10px
    p
      text-align center
      font-size $font_size_big
      padding-bottom 10px
      line-height: 24px;
      color: #303133;
    .download_file
      color $color_suc
      font-weight bold
      cursor pointer
  .tabel_head
    border  1px solid $color_text_secondary
    display flex
    div
      flex 1
      height 40px
      text-align center
      line-height 40px
      &:first-child
        border-right 1px solid $color_text_secondary
  .tabel_body
    border  1px solid $color_text_secondary
    display flex
    border-top 0
    .practice,.theory
      flex 1
      padding 20px 0 0 20px
    .theory
      border-right 1px solid $color_text_secondary
  .sysm_tea_edit
    display flex
    justify-content center
    align-items center
    margin-top 15px
    .el-button--danger
      background-color $color_err
  .info
    display flex
    font-size 16px
    .practice_info
      flex-basis 50%
      border-left 1px solid $color_text_secondary
      border-bottom 1px solid $color_text_secondary
      border-right 1px solid $color_text_secondary
      min-height 200px
      display flex;
      justify-content center;
      align-items center
    .theory_info
      flex-basis 50%
      border-left 1px solid $color_text_secondary
      border-bottom 1px solid $color_text_secondary
      min-height 200px
      display flex
      justify-content center
      align-items center
</style>
